import { render, staticRenderFns } from "./KBKLimitSelectorList.view.vue?vue&type=template&id=0c162bac&"
import script from "./KBKLimitSelectorList.view.vue?vue&type=script&lang=js&"
export * from "./KBKLimitSelectorList.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c162bac')) {
      api.createRecord('0c162bac', component.options)
    } else {
      api.reload('0c162bac', component.options)
    }
    module.hot.accept("./KBKLimitSelectorList.view.vue?vue&type=template&id=0c162bac&", function () {
      api.rerender('0c162bac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/themes/atmo/views/overlays/popups/dictionaries/limits/KBKLimitSelectorList.view.vue"
export default component.exports